import { Component } from '@angular/core';
import { QuantityInputBareComponent } from 'shared/components/shared/base/quantity-input/quantity-input-bare/quantity-input-bare.component';

@Component({
    selector: 'app-quantity-input-bare',
    templateUrl: './quantity-input-bare.component.html',
    standalone: false
})
export class QuantityInputBareMHComponent extends QuantityInputBareComponent { }
